<template>
    <div class="section text-center mt-1" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div class="section mt-1" v-if="!loading && showAddForm">
        <div class="wallet-card">
            <h3 class="text-center mb-3">Add New Mentor</h3>
            <Form @submit="assignMentor">
                <div class="wallet-card mt-1">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="member">Member</label>
                                    <v-select 
                                        label="text" 
                                        :filterable="true"
                                        v-model="new_member" 
                                        :value="new_member" 
                                        :options="member_list"
                                        @search="getTextList"
                                        @input="handleMemberSelect">
                                        <template>
                                            type to search...
                                        </template>
                                        <template>
                                            <div class="d-center">
                                                {{ new_member ? new_member.name : '' }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <span v-if="showMemberError" class="error-feedback">Please select a member</span>
                                </div>
                            </div>
                            <div class="input-info" v-if="new_member">
                                Mobile: {{ new_member.country_code }} {{ new_member.mobile }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between mt-3">
                    <button type="button" class="btn btn-secondary btn-md" @click="showAddForm = false">Cancel</button>
                    <button type="submit" class="btn btn-primary btn-md" :disabled="btn_loading">
                        <span v-show="btn_loading" class="spinner-border spinner-border-sm"></span>
                        <span>Save</span>
                    </button>
                </div>
            </Form>
        </div>
    </div>
    <div class="section mt-1" v-if="!loading">
        <div class="wallet-card">
            <h4 class="mb-3">Mentor List</h4>
            <div class="table-responsive" style="max-height: 400px;">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 60px;">SL</th>
                            <th scope="col">Name</th>
                            <th scope="col">Mobile</th>
                            <th scope="col">Unit</th>
                        </tr>
                    </thead>
                    <tbody style="max-height: 350px; overflow-y: auto;">
                        <tr v-for="(mentor, index) in mentor_list" :key="mentor.id || mentor.mentor_id">
                            <td>{{ index + 1 }}</td>
                            <td>{{ mentor.mentor_name || mentor.member?.name || mentor.name || '' }}</td>
                            <td>{{ mentor.mentor_phone || mentor.member?.mobile || mentor.mobile || '' }}</td>
                            <td>{{ mentor.member?.unit_name || mentor.unit_name || '' }}</td>
                        </tr>
                        <tr v-if="mentor_list.length === 0">
                            <td colspan="4" class="text-center text-muted">No mentors assigned yet</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="section mt-1" v-if="!loading && !showAddForm">
        <button type="button" class="btn btn-primary btn-block btn-md" @click="showAddForm = true">
            Add Mentor
        </button>
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import {
    Form
} from "vee-validate";
import $ from "jquery";
import UserService from "../../services/user.service";
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    name: "Assign Mentors",
    components: {
        Form,
        AlertModel,
        DialogModel,
        vSelect
    },
    data() {
        return {
            showAddForm: false,
            new_member: null,
            new_member_id: "",
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: [],
            loading: false,
            btn_loading: false,
            campaign_details: null,
            campaign_id: null,
            member_list: [],
            mentor_list: [],
            currentUser: null,
            showMemberError: false,
        };
    },
    mounted() {
        this.currentUser = this.$store.state.auth.user;
        if (!this.currentUser) {
            location.replace("/");
        }
        this.campaign_id = this.$route.params.id;
        if (!this.campaign_id) {
            this.alert_type = 'Error';
            this.alert_message = 'Campaign ID is required';
            this.$refs.alert_model.openModel();
            return;
        }
        this.$root.updateParent("Assign Mentors");
        this.getCampaignDetails();
        window.onpopstate = function () {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        getTextList(searchQuery) {
            if (!searchQuery || searchQuery.length < 2) {
                return;
            }
            this.message = '';
            let data = {
                q: searchQuery,
                type: 0,
                filter: 'inside',
                unit_id: this.currentUser.unit_id,
                user_level: this.currentUser.user_level
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        handleMemberSelect(selectedMember) {
            if (selectedMember && selectedMember.id) {
                this.new_member = selectedMember;
                this.new_member_id = selectedMember.id;
                this.showMemberError = false;
            } else {
                this.new_member = null;
                this.new_member_id = '';
            }
        },
        getCampaignDetails() {
            this.loading = true;
            let data = {
                id: this.campaign_id
            };
            UserService.authPostRequest('v2/get-call-campign', data).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.campaign_details = response.data.data.campign;
                        this.getMentorList();
                    } else {
                        this.loading = false;
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message || 'Failed to load campaign details';
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && 
                        error.response.data && 
                        error.response.data.message) || 
                        'Failed to load campaign details';
                    this.$refs.alert_model.openModel();
                }
            );
        },
        getMentorList() {
            let data = {
                campaign_id: this.campaign_id
            };
            UserService.authPostRequest('v2/get-campaign-mentors', data).then(
                (response) => {
                    this.loading = false;
                    if (response.data.status == "success") {
                        // API returns mentors array, not mentor_list
                        this.mentor_list = response.data.data.mentors || response.data.data.mentor_list || [];
                        this.member_list = response.data.data.members || [];
                    } else {
                        this.mentor_list = [];
                        this.member_list = [];
                    }
                },
                () => {
                    this.loading = false;
                    // If API doesn't exist yet, set empty lists
                    this.mentor_list = [];
                    this.member_list = [];
                }
            );
        },
        assignMentor() {
            if (!this.new_member || !this.new_member.id) {
                this.showMemberError = true;
                this.alert_type = 'Warning';
                this.alert_message = 'Please select a member';
                this.$refs.alert_model.openModel();
                return;
            }
            this.showMemberError = false;
            
            this.btn_loading = true;
            let formData = {
                member_id: this.new_member.id,
                campaign_id: this.campaign_id
            };

            UserService.authPostRequest('v2/assign-campaign-mentor', formData).then(
                (response) => {
                    this.btn_loading = false;
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message || 'Mentor assigned successfully';
                        this.$refs.alert_model.openModel();
                        
                        // Reset form
                        this.new_member = null;
                        this.new_member_id = '';
                        this.showAddForm = false;
                        
                        // Refresh mentor list
                        this.getMentorList();
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message || 'Failed to assign mentor';
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.btn_loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && 
                        error.response.data && 
                        error.response.data.message) || 
                        'Failed to assign mentor';
                    this.$refs.alert_model.openModel();
                }
            );
        },
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.table-responsive {
    overflow-y: auto;
    border: 1px solid #eee;
    border-radius: 8px;
}

.table {
    margin-bottom: 0;
}

.table thead th {
    background: #fff;
    border-bottom: 2px solid #dee2e6;
    position: sticky;
    top: 0;
    z-index: 1;
}

.table tbody {
    border-top: none;
}

.table td, .table th {
    padding: 10px;
    vertical-align: middle;
}

.wallet-card {
    background: #ffffff;
    border-radius: 10px;
    padding: 15px;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0px;
    height: auto;
}

.wallet-card .balance .total {
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1em;
    font-size: 24px;
}

.wallet-card .balance .title {
    color: #27173e;
    font-weight: 500;
    font-size: 14px;
    display: block;
    margin-bottom: 0px;
}

.input-info {
    font-size: 12px;
    color: #6c757d;
    margin-top: 5px;
}
</style>

